import { Component } from "./component"
import { handleComponentError } from "../decorators/handleComponentError"
import { ImageComponentInterface } from "../types/imageComponent"

export class ImageComponent extends Component<ImageComponentInterface> {
    setImage(urlImage?: string) {
        if (urlImage) {
            ;(this.element as HTMLImageElement).src = urlImage
        }
    }

    @handleComponentError("ImageComponent")
    render() {
        this.setImage(this.props.urlImage)
        this.show(this.props.isVisible && !!this.props.urlImage)
        super.render()
    }
}
